import { SKILLS_ROUTES } from '../../constants/_routes'
import { formatRoute } from 'react-router-named-routes'
import skillsTypes from '../../constants/skillsTypes'
import { axios } from '../../services'

// import { try_force_logoff } from '../auth'

const update_skill_request = () => {
  return {
    type: skillsTypes.update.request
  }
}

const update_skill_success = (response) => {
  return {
    type: skillsTypes.update.success,
    payload: response.data.skill
  }
}

const update_skill_failure = (messages) => {
  return {
    type: skillsTypes.update.failure,
    payload: messages
  }
}

const update_skill = (skill_id, values) => {
  return function (dispatch) {
    // Before Request
    dispatch(update_skill_request())

    // Request
    axios.patch(
      formatRoute(SKILLS_ROUTES.update, {id: skill_id}),
      values
    ).then( response => {
      // success
      dispatch( update_skill_success(response) )

    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error updating skill."]
      }
      // dispatch( try_force_logoff(error.response) )
      dispatch( update_skill_failure(errors))
    })
  }

}

export {
  update_skill
}



// WEBPACK FOOTER //
// ./src/js/actions/skills/update.js